import type { Procedure } from '../../../../app-core/lib/procedure/Procedure'
import type { AppUnitType } from '../../../../shared/domain/units/types.no-deps'
import type { Form_IForm } from '../../../zap/Form/Form.types'
import { IDB_actionTypesReadAll } from '../../../zap/IDB/IDB.table.actionType'
import { IDB_calendarEventsReadAll } from '../../../zap/IDB/IDB.table.calendarEvent'
import { IDB_formsReadAll } from '../../../zap/IDB/IDB.table.form'
import { IDB_locationsReadAll } from '../../../zap/IDB/IDB.table.location'
import { IDB_locationFocusListsReadAll } from '../../../zap/IDB/IDB.table.locationFocusList'
import { IDB_proceduresReadAll } from '../../../zap/IDB/IDB.table.procedure'
import { IDB_reportsReadAll } from '../../../zap/IDB/IDB.table.report'
import { IDB_unitsReadAll } from '../../../zap/IDB/IDB.table.unit'
import { IDB_unitListsReadAll } from '../../../zap/IDB/IDB.table.unitList'
import { IDB_unitTypesReadAll } from '../../../zap/IDB/IDB.table.unitType'
import { IDB_workflowsReadAll } from '../../../zap/IDB/IDB.table.workflow'
import type { NReports } from '../../../zap/Rpts/Rpts.types'
import type {
    Type_IActionType,
    Type_ICalendarEvent,
    Type_ILocation,
    Type_ILocationFocusList,
    Type_IUnit,
    Type_IUnitList,
    Type_Workflow,
} from '../../../zap/Type/Type.hive'

export async function fetchActivities() {
    return IDB_workflowsReadAll().catch<Type_Workflow[]>(() => [])
}

export async function fetchActionTypes() {
    return IDB_actionTypesReadAll().catch<Type_IActionType[]>(() => [])
}

export async function fetchCalendarEvents() {
    return IDB_calendarEventsReadAll().catch<Type_ICalendarEvent[]>(() => [])
}

export async function fetchCampaigns() {
    return IDB_proceduresReadAll().catch<Procedure[]>(() => [])
}

export async function fetchFocusLists() {
    return IDB_locationFocusListsReadAll().catch<Type_ILocationFocusList[]>(() => [])
}

export async function fetchForms() {
    return IDB_formsReadAll().catch<Form_IForm[]>(() => [])
}

export async function fetchLocations() {
    return IDB_locationsReadAll().catch<Type_ILocation[]>(() => [])
}

export async function fetchReports() {
    return IDB_reportsReadAll().catch<NReports.TDatabaseReport[]>(() => [])
}

export async function fetchUnits() {
    return IDB_unitsReadAll().catch<Type_IUnit[]>(() => [])
}

export async function fetchUnitTypes() {
    return IDB_unitTypesReadAll().catch<AppUnitType[]>(() => [])
}

export async function fetchUnitLists() {
    return IDB_unitListsReadAll().catch<Type_IUnitList[]>(() => [])
}
